import type React from 'react';
import { useKeyboardShortcuts, type KeyboardShortcutHandlers } from '../hooks/useKeyboardShortcuts';

/**
 * Mounts the application keyboard shortcuts. Renders nothing.
 *
 * Kept as a component so the shortcut wiring stays declarative next to the rest
 * of the shell instead of hiding in an effect halfway up a 2,000-line file.
 */
export const AppShortcuts: React.FC<KeyboardShortcutHandlers> = (handlers) => {
  useKeyboardShortcuts(handlers);
  return null;
};
